import HttpClient from '../../../services/http-client';
import { Pagination } from '../../../../model/pagination';
import { ICustomPagePagedRequest } from '../../../../model/apm/custom-page/request/custom-page-paged-request';
import { ICustomPageAddEditRequest } from '../../../../model/apm/custom-page/request/custom-page-add-edit-request';
import { ICustomPageSectionAddEditRequest } from '../../../../model/apm/custom-page/request/custom-page-section-add-edit-request';
import { ICustomPageSectionItemAddEditRequest } from '../../../../model/apm/custom-page/request/custom-page-section-item-add-edit-request';
import { ICustomPagePagedResponse } from '../../../../model/apm/custom-page/response/custom-page-paged-response';
import { ICustomPageResponse } from '../../../../model/apm/custom-page/response/custom-page-response';
import { ICustomPageSectionResponse } from '../../../../model/apm/custom-page/response/custom-page-section-response';
import { ICustomPageSectionItemResponse } from '../../../../model/apm/custom-page/response/custom-page-section-item-response';

const defaultPath = 'CustomPage';

// Paginação 0-based; a API limita PageSize a 100
const list = async (params: ICustomPagePagedRequest): Promise<Pagination<ICustomPagePagedResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}`,
        params: {
            Term: params.term || undefined,
            IsPublished: params.isPublished,
            Page: params.page,
            PageSize: params.pageSize,
        }
    }).then((response) => Object.assign(new Pagination<ICustomPagePagedResponse>(), response.data));
};

const getById = async (id: number): Promise<ICustomPageResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        url: `/${defaultPath}/${id}`
    }).then((response) => response.data);
};

const add = async (params: ICustomPageAddEditRequest): Promise<ICustomPageResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}`,
        data: params
    }).then((response) => response.data);
};

const edit = async (id: number, params: ICustomPageAddEditRequest): Promise<ICustomPageResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}`,
        data: params
    }).then((response) => response.data);
};

const remove = async (id: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}`
    });
};

const changePublication = async (id: number, isPublished: boolean): Promise<ICustomPageResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}/Publication`,
        data: { isPublished }
    }).then((response) => response.data);
};

const addSection = async (id: number, params: ICustomPageSectionAddEditRequest): Promise<ICustomPageSectionResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/${id}/Section`,
        data: params
    }).then((response) => response.data);
};

const editSection = async (id: number, sectionId: number, params: ICustomPageSectionAddEditRequest): Promise<ICustomPageSectionResponse> => {
    const { type, ...data } = params;
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}/Section/${sectionId}`,
        data
    }).then((response) => response.data);
};

const removeSection = async (id: number, sectionId: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/${id}/Section/${sectionId}`
    });
};

const reorderSections = async (id: number, ids: number[]): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/${id}/Section/Order`,
        data: { ids }
    });
};

const addItem = async (sectionId: number, params: ICustomPageSectionItemAddEditRequest): Promise<ICustomPageSectionItemResponse> => {
    return await HttpClient.executeRequest({
        method: 'post',
        url: `/${defaultPath}/Section/${sectionId}/Item`,
        data: params
    }).then((response) => response.data);
};

const editItem = async (sectionId: number, itemId: number, params: ICustomPageSectionItemAddEditRequest): Promise<ICustomPageSectionItemResponse> => {
    return await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/Section/${sectionId}/Item/${itemId}`,
        data: params
    }).then((response) => response.data);
};

const removeItem = async (sectionId: number, itemId: number): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'delete',
        url: `/${defaultPath}/Section/${sectionId}/Item/${itemId}`
    });
};

const reorderItems = async (sectionId: number, ids: number[]): Promise<void> => {
    await HttpClient.executeRequest({
        method: 'put',
        url: `/${defaultPath}/Section/${sectionId}/Item/Order`,
        data: { ids }
    });
};

const CustomPageAppService = {
    list, getById, add, edit, remove, changePublication,
    addSection, editSection, removeSection, reorderSections,
    addItem, editItem, removeItem, reorderItems
};
export default CustomPageAppService;
